// extracted by mini-css-extract-plugin
export default {"Card":"PolicyQuoteCard2_Card__izZqO","selected":"PolicyQuoteCard2_selected__Gwz90","expired":"PolicyQuoteCard2_expired__ztpMi","carrierLogo":"PolicyQuoteCard2_carrierLogo__XJ5xo"};